// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
    margin: 0;
    padding: 0;

    width: 100%;
    min-height: 100%;
}

* {
    box-sizing: border-box;
}

body {
    min-width: 320px;
    font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    -webkit-font-smoothing: antialiased;
}

button,
input,
textarea,
select {
    font: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;IAGI,SAAS;IACT,UAAU;;IAEV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kFAAkF;IAClF,mCAAmC;AACvC;;AAEA;;;;IAII,aAAa;AACjB","sourcesContent":["html,\nbody,\n#root {\n    margin: 0;\n    padding: 0;\n\n    width: 100%;\n    min-height: 100%;\n}\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    min-width: 320px;\n    font-family: Pretendard, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n    font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
